export const environment = {
    production: true,
    hmr       : false,
    mode: 'prod'
};
